// extracted by mini-css-extract-plugin
export default {"container":"YAxis_container__2VhSg","unitsContainer":"YAxis_unitsContainer__A0XQK","units":"YAxis_units__vLy9u","labels":"YAxis_labels__iXgI0"};